<template>
  <gs-named-modal class="gs-refresh-controls gs-aff-modal" name="add-membership-file-modal" width="640px" max-width="640px" :title="isEditing === false ? 'Add New File' : 'Edit File'">
    <div class="gs-aff-form">
      <p>Choose the file buyers receive with this price point.</p>
      <label>{{ $t('frontend_groovesell_select_file') }}
        <gs-name-select v-model="localpostMembershipFileId" size="full" :placeholder="$t('frontend_groovesell_select_file')" :options="membershipFileOptions" />
      </label>
    </div>
    <div slot="footer" class="gs-aff-footer">
      <gs-button variant="outline" @click="$root.$emit('modal-close', 'add-membership-file-modal')">{{ $t('frontend_close') }}</gs-button>
      <gs-button v-if="isEditing == false" variant="primary" @click="addMembershipFile()">{{ $t('frontend_add') }}</gs-button>
    </div>
  </gs-named-modal>
</template>
<script>
import "../../affiliate-workspace.css";
export default {
    props: {
        isEditing: {
            type: Boolean,
            required: true,
        },
        postMembershipFileId: {
            required: true,
        },
        membership_files: {
            required: true,
        },
        post_addbtn: {
            required: true,
        },
        addMembershipFile: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            localpostMembershipFileId: this.postMembershipFileId,
        };
    },
    computed: {
        gdButtonVariant() {
            return this.post_addbtn ? 'primary' : 'base';
        },
        membershipFileOptions() {
            return this.membership_files.map(file => ({ value: file.id, text: file.name }));
        },
    },
    watch: {
        localpostMembershipFileId() {
            this.$emit('update-data', {
                key: 'postMembershipFileId',
                value: this.localpostMembershipFileId,
            });
        },
    },
};

</script>
